import { SchemaPath, validate, ValidationError } from '@angular/forms/signals';

const BYTES_IN_MB = 1024 * 1024;

export interface FilesMaxSizeError extends ValidationError {
  readonly kind: 'filesMaxSizeExceeded';
  readonly maxSizeInMB: number;
  readonly actualSizeInMB: number;
}

export const isFilesMaxSizeError = (error: ValidationError): error is FilesMaxSizeError =>
  error.kind === 'filesMaxSizeExceeded';

/** Signal Forms rule: the total size of the selected files does not exceed `maxSizeInMB`. */
export function filesMaxSize(path: SchemaPath<File[]>, maxSizeInMB: number, options: { message?: string } = {}): void {
  validate(path, ({ value }) => {
    const totalSize = value().reduce((sum, file) => sum + file.size, 0);
    if (totalSize <= maxSizeInMB * BYTES_IN_MB) {
      return undefined;
    }

    const error: FilesMaxSizeError = {
      kind: 'filesMaxSizeExceeded',
      message: options.message,
      maxSizeInMB,
      actualSizeInMB: +(totalSize / BYTES_IN_MB).toFixed(2)
    };
    return error;
  });
}
